module.exports = __webpack_public_path__ + "img/01_valuation.19aa493d.svg";